import React, {useRef} from "react";
import PropTypes from "prop-types";
import Grid from "@mui/material/Grid";
import {MSpinner, MScorecard} from "components/Shared";

const MScorescreen =  ({scorecardData}) => {
  const ref = useRef(null);
  return scorecardData ? (
    <div style={{ padding: 8 }}>
      <Grid 
        container
        direction="row"
        spacing={1}
      >
        {scorecardData.data.map((metric, key) => 
          <Grid
            {...key === 0 ? {ref} : {}}
            key={key}
            item
            xs={2}
            sx={{ minWidth: ref.current ? ref.current.clientWidth : "unset" }}
          >
            <MScorecard {...{metric}}/>
          </Grid>
        )}
      </Grid>
    </div>
  ) : (
    <MSpinner/>
  );
};

MScorescreen.propTypes = {
  scorecardData: PropTypes.object //Data from backend
};

export default MScorescreen;